import * as React from 'react';
import Box from '@mui/material/Box';
//import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
//import IconButton from '@mui/material/IconButton';
//import Link from '@mui/material/Link';
//import Stack from '@mui/material/Stack';
//import TextField from '@mui/material/TextField';
//import Typography from '@mui/material/Typography';

/*
const logoStyle = {
  width: '140px',
  height: 'auto',
  };

function Copyright() {
  return (
    <Typography variant="body2" color="text.secondary" mt={1}>
      {'Copyright © '}
      <Link href="https://mui.com/">Sitemark&nbsp;</Link>
      {new Date().getFullYear()}
    </Typography>
  );
  }
  */

export default function Footer() {
  return (
    <Container
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: { xs: 4, sm: 8 },
        py: { xs: 8, sm: 10 },
        textAlign: { sm: 'center', md: 'left' },
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', sm: 'row' },
          width: '100%',
          justifyContent: 'space-between',
        }}
      >
      </Box>
    </Container>
  );
}
